import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import { AppLayout } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { RequireAuth } from "./auth/RequireAuth";
import { CampaignStatsPage } from "./pages/ops/CampaignStatsPage";
import { PlatformStatsPage } from "./pages/ops/PlatformStatsPage";
import { UserPhoneLookupPage } from "./pages/ops/UserPhoneLookupPage";
import { BrandMetricsPage } from "./pages/products/BrandMetricsPage";
import { CampaignImpactPage } from "./pages/products/CampaignImpactPage";
import { CatalogSearchPage } from "./pages/products/CatalogSearchPage";
import { ProductDemandPage } from "./pages/products/ProductDemandPage";
import { ProductRawPage } from "./pages/products/ProductRawPage";
import { UpcComparePage } from "./pages/products/UpcComparePage";
import { UpcMetricsPage } from "./pages/products/UpcMetricsPage";
import { RetailerActivityPage } from "./pages/retailer/RetailerActivityPage";
import { RetailerRedemptionsPage } from "./pages/retailer/RetailerRedemptionsPage";
import { ShopperGrowthPage } from "./pages/retailer/ShopperGrowthPage";
import "./index.css";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/ops" replace /> },
      { path: "ops", element: <PlatformStatsPage /> },
      { path: "ops/campaigns", element: <CampaignStatsPage /> },
      { path: "ops/user-lookup", element: <UserPhoneLookupPage /> },
      { path: "retailer", element: <RetailerRedemptionsPage /> },
      { path: "retailer/activity", element: <RetailerActivityPage /> },
      { path: "retailer/shoppers", element: <ShopperGrowthPage /> },
      { path: "products", element: <Navigate to="/products/campaigns" replace /> },
      { path: "products/campaigns", element: <CampaignImpactPage /> },
      { path: "products/brand", element: <BrandMetricsPage /> },
      { path: "products/upc", element: <UpcMetricsPage /> },
      { path: "products/compare", element: <UpcComparePage /> },
      { path: "products/demand", element: <ProductDemandPage /> },
      { path: "products/raw", element: <ProductRawPage /> },
      { path: "products/catalog", element: <CatalogSearchPage /> },
    ],
  },
]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider
      onRedirectCallback={(appState) =>
        void router.navigate(appState?.returnTo ?? "/", { replace: true })
      }
    >
      <RouterProvider router={router} />
    </AuthProvider>
  </StrictMode>,
);
